import { render, staticRenderFns } from "./ImportExport.vue?vue&type=template&id=846970b8&"
import script from "./ImportExport.vue?vue&type=script&lang=js&"
export * from "./ImportExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\manla\\Downloads\\b\\public_html\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('846970b8')) {
      api.createRecord('846970b8', component.options)
    } else {
      api.reload('846970b8', component.options)
    }
    module.hot.accept("./ImportExport.vue?vue&type=template&id=846970b8&", function () {
      api.rerender('846970b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/ImportExport.vue"
export default component.exports